module.exports = __webpack_public_path__ + "img/icon-AI-profile.cfab9d6.png";